import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../../components/Constant/cta/CTA";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function ReadyMadeCompaniesWesternSahara() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.ready-made-companies-western-sahara.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/ready-made-companies-western-sahara"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../../assets/images/ready-made/ready-made-western-sahara.png')}
                imageAlt={tp('intro.imageAlt')}
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('what.title')}
                        subtitle={tp('what.subtitle')}
                        blocks={[]}
                    />

                    <WhySection
                        title={tp('why.title')}
                        blocks={[{ items: obj('why.items') }]}
                    />

                    <WhySection
                        title={tp('package.title')}
                        subtitle={tp('package.subtitle')}
                        blocks={[{ items: obj('package.items') }]}
                    />

                    <InfoBlocks
                        title={tp('how.title')}
                        blocks={obj('how.blocks')}
                    />

                    <WhySection
                        title={tp('useCases.title')}
                        blocks={[{ items: obj('useCases.items') }]}
                    />

                    <WhySection
                        title={tp('pricing.title')}
                        blocks={[{ items: obj('pricing.items') }]}
                    />


                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <DetailsSection
                        title={tp('whyUs.title')}
                        items={obj('whyUs.items')}
                        />
                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />


                </div>
            </section>
        </main>
    );
};
